import axios from 'axios'
import strings from 'keycloak/strings/english'
import { TwitterRoles } from 'utils/consts'
import { encodeBase64, getBrowserDetail } from 'utils/helpers'
// import crypto from 'crypto'
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API,
  timeout: 500000
})
axiosInstance.interceptors.request.use(
  async (config) => {
    // config.headers.Authorization = `Bearer ${process.env.REACT_APP_TWITTER_BEARER_TOKEN}`
    // config.headers.withCredentials = true
    // config.headers['Content-Type'] = "application/x-www-form-urlencoded"
    return config
  },
  (error) => {
    console.log('axios.interceptors error')
    return error
  }
)

function base64UrlEncode(data) {
  let base64 = data.toString('base64');
  let base64Url = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  return base64Url;
}
// export const doTwitterLogin = async (refSrc, role) => {
//   try {
//     let data = { riddle: refSrc, twitter_role: role }
//     data = encodeBase64(JSON.stringify(data))

//     const codeVerifierBytes = crycpto.randomBytes(32);
//     const codeVerifier = base64UrlEncode(codeVerifierBytes);
//     const codeVerifierBytesVerifier = Buffer.from(codeVerifier, 'ascii');
//     const codeChallengeBytes = crypto.createHash('sha256').update(codeVerifierBytesVerifier).digest();
//     const codeChallenge = base64UrlEncode(codeChallengeBytes);
//     const queryParams = {
//         client_id: process.env.REACT_APP_TWITTER_CLINET_ID,
//         redirect_uri: `${process.env.REACT_APP_TWITTER_REDIRACT_URI}?rediract_data=${data}`,
//         response_type: 'code',
//         state: crypto.randomUUID(),
//         code_challenge: codeChallenge,
//         code_challenge_method: 'S256',
//         scope: role === TwitterRoles.RETWEET_RIDDLE
//         ? 'tweet.read%20tweet.write%20users.read%20like.write'
//         : 'tweet.read%20tweet.write%20users.read'

//     };
//     let twitterQueryParams = new URLSearchParams(queryParams);
//     const twitterAuthUrl = `https://twitter.com/i/oauth2/authorize?${twitterQueryParams.toString()}`
//     window.open(twitterAuthUrl, '_self')
//   } catch (error) {
//     console.log("error:>::", error)
//   }
// }

export const getUserInfoToken = async (code, src, ssoAccessToken, rediract_data) => {
  try {
    // const hash = encryptMessagePublicKey(
    //   JSON.stringify({ code, rediractUrl }),
    //   process.env.REACT_APP_PUBLIC_KEY
    // )
    const rediractUrl = `${process.env.REACT_APP_TWITTER_REDIRACT_URI}?rediract_data=${rediract_data}`
    const twitterAccessUrl = `/token`
    const responce = await axiosInstance.post(
      twitterAccessUrl,
      {
        code,
        rediractUrl
      },
      {
        headers: {
          Authorization: `bearer ${ssoAccessToken}`
        }
      }
    )
    return responce?.data ?? null
  } catch (error) {
    return null
  }
}
export const doReTweet = async (
  tweetID,
  accessToken,
  message,
  twitterUserID,
  riddleDocID,
  ssoAccessToken
) => {
  try {
    const browserDetail = getBrowserDetail()
    const twitterRetweetUrl = `/tweet`
    const responce = await axiosInstance.post(
      twitterRetweetUrl,
      {
        tweetID,
        accessToken,
        message,
        twitterUserID,
        riddleDocID,
        game_id: process.env.REACT_APP_GAME_ID,
        version: browserDetail?.version ?? '',
        device_id: browserDetail?.device_id ?? '',
        platform: 'web'
      },
      {
        headers: {
          Authorization: `bearer ${ssoAccessToken}`
        }
      }
    )
    return responce?.data ?? null
  } catch (error) {
    console.log('error::', error)
    return error?.response?.data ?? null
  }
}

export const doTweetForSuccess = async (
  tweetID,
  accessToken,
  message,
  twitterUserID,
  riddleDocID,
  ssoAccessToken
) => {
  try {
    const browserDetail = getBrowserDetail()
    const twitterRetweetUrl = `/share`
    const responce = await axiosInstance.post(
      twitterRetweetUrl,
      {
        tweetID,
        accessToken,
        message,
        twitterUserID,
        riddleDocID,
        game_id: process.env.REACT_APP_GAME_ID,
        version: browserDetail?.version ?? '',
        device_id: browserDetail?.device_id ?? '',
        platform: 'web'
      },
      {
        headers: {
          Authorization: `bearer ${ssoAccessToken}`
        }
      }
    )
    return responce?.data ?? null
  } catch (error) {
    console.log('error::', error)
    return error?.response?.data ?? null
  }
}
